import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/auth/AppAuthContext";
import { InfoPageLayout } from "../Layouts/InfoPageLayout";
import { doSendEmailVerification } from "../firebase/auth";
import { useState } from "react";

export function VerifyEmail() {
    const { userLoggedIn, currentUser } = useAuth();

    const [isSendingEmail, setIsSendingEmail] = useState(false);

    const navigate = useNavigate();

    if (!userLoggedIn) {
        navigate('/login', { replace: true });
    }

    const handleSendEmailVerification = async () => {
        setIsSendingEmail(true);
        await doSendEmailVerification();
        setIsSendingEmail(false);
    }
    
    return (
        <InfoPageLayout>
            <main className="flex flex-1 self-center place-content-center place-items-center mt-[10%]">
                <div className="w-96 text-gray-600 space-y-5 p-4 shadow-xl border rounded-xl">
                    <div className="text-center">
                        <div className="mt-2">
                            <h3 className="text-gray-800 text-xl font-semibold sm:text-2xl">Verify Your Email</h3>
                        </div>
                    </div>
                    {currentUser.emailVerified ? 
                    <div className="mt-4 flex flex-col items-center justify-center">
                        <p className="text-center">Your email has been verified.</p>
                        <button className="primary-button mt-4" onClick={() => navigate('/account', { replace: true })}>Go to Account</button>
                    </div> : 
                    <div className="mt-4 flex flex-col items-center justify-center">
                        <p className="text-center">A verification email has been sent to {currentUser?.email}. Please check your email and verify your account.</p>
                        <p className="text-center text-sm">Please reload the page once your email has been verified.</p>
                        <button className="primary-button mt-4" onClick={handleSendEmailVerification}>Send Email Again</button>
                        {isSendingEmail && <p className="text-center mt-2">Sending email...</p>}
                    </div>}
                </div>
            </main>
        </InfoPageLayout>
    );
}